import { Box, Icon, NotificationCard, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { MSSNotificationType } from '@lib/types';

export const RestrictedNotification = () => {
  return (
    <NotificationCard
      severity={MSSNotificationType.WARNING}
      sx={{ maxWidth: '100%' }}
      slotProps={{
        alert: {
          icon: <Icon iconName={'circle-info-regular'} />,
        },
      }}
    >
      <Typography className={`dependent-notification`} variant="b2Regular">
        <Stack direction="row" alignItems={'center'}>
          <Box>Only the primary can make payments and changes to the membership.</Box>
        </Stack>
      </Typography>
    </NotificationCard>
  );
};
